<template>
  <ul class="combine-list list">
   <!-- <li class="combine-item"
        v-if="!isVirtual"
        @click="mergeGroup">
      <button type="button" class="list-item">
        {{$t('things.combine.combineGroup')}}
      </button>
    </li>-->
    <li class="combine-item"

        @click="mergeVirtual">
      <button type="button"
              class="list-item"
              :class="{'list-item_disabled hint-cont': disabledVirtualIfGroup}">
        {{$t('things.combine.combineMulti')}}
        <p v-if="disabledVirtualIfGroup"
           class="btn-hint btn-hint_bottom">
          {{$t('things.mergeGroupDisable')}}
        </p>
      </button>

    </li>
  </ul>
</template>

<script>
  import {mapState,mapMutations} from 'vuex'
  import {combineThings} from "../../../../../mixins/things/combineThings";
  import {showOverlay} from "../../../../../mixins/utils/showOverlay";

  export default {
    name: 'combineList',
    props: {
      isVirtual: {
        type: Boolean,
        default: false
      }
    },
    mixins: [combineThings, showOverlay],
    computed: {
      ...mapState({
        mergeGroupId: state => state.things.mergeGroupId,
        isMergeGroup: state => state.things.isMergeGroup,

        mergeVirtualId: state => state.things.mergeVirtualId,
        isMergeVirtual: state => state.things.isMergeVirtual,

        checkedThings: state => state.things.checkedThingList,

      }),
      disabledVirtualIfGroup() {
        let marker = false;
        for (let i = 0; i < this.checkedThings.length; i++) {
          if (this.checkedThings[i].type === 'group') {
            marker = true;
            break;
          }
        };
        return marker
      }
    },
    watch: {
      mergeGroupId(val) {
        if (this.isMergeGroup) {
          this.checkedThings.forEach(item => {
            if (item.type === 'group') {
              this.updateGroupMerged(val, item)
            } else {
              this.updateThingMerged(val, item);
            }
          });

          this.clearMerged()
        }
      },
      mergeVirtualId(val) {
        if (this.isMergeVirtual) {
          this.updateVirtualMerged(val);

          this.clearMerged();
        }
      }
    },
    methods: {
      ...mapMutations({
        showAddThingPopup: 'popups/addThing/SET_SHOW',
        setType: 'popups/addThing/SET_TYPE',
        setMergeGroup: 'things/SET_MERGE_GROUP',
        setMergeVirtual: 'things/SET_MERGE_VIRTUAL',
        setChecked: 'things/SET_CHECKED_THINGS_LIST',
        showErrorMerge: 'things/SET_ERROR_MERGE_THING'
      }),
      /*mergeGroup() {
        this.showOverlay(true);
        this.showAddThingPopup(true);
        this.setType('group');
        this.setMergeGroup(true);
      },*/
      mergeVirtual() {
        if (!this.disabledVirtualIfGroup) {
          this.showOverlay(true);
          this.showAddThingPopup(true);
          this.setType('multi');
          this.setMergeVirtual(true);
        }
      },
      async updateVirtualMerged(val) {
        /*let string = '';
        this.checkedThings.forEach(item => {
          string += `${item.id},`
        });
        string = string.slice(0,-1);*/

        /*this.checkedThings.forEach(item => {
          let updateObj = {
            device_id: item.id,
            parent_device_id: val,
            source: 1,
            source_connect_token: 1
          };
          let formData = this.toFormData(updateObj);
          this.updateThing(formData).catch(e => {
            this.showOverlay(true);
            this.showErrorMerge(true)
          });
        });*/

        for (let i = 0; i < this.checkedThings.length; i++) {
          let item = this.checkedThings[i]


          let updateObj = {
            device_id: item.id,
            parent_device_id: val,
            source: 1,
            source_connect_token: 1
          };
          let formData = this.toFormData(updateObj);
          this.updateThing(formData).catch(e => {
            this.showOverlay(true);
            this.showErrorMerge(true)
          });

          if (i === this.checkedThings.length - 1) {
            await this.reloadThings()
          }
        }


        /*let data = {
         // access_token: this.token,
          //subdevices: string,
          device_id: val,
          source: 1,
          source_connect_token: 1
        };
        let formData = this.toFormData(data);
        await this.updateThing(formData).catch(e => {
          this.showOverlay(true);
          this.showErrorMerge(true)
        })*/
      },
      clearMerged() {
        this.setMergeGroup(false);
        this.setMergeVirtual(false);
        this.setChecked([]);
        this.updateThings();
      },


    }
  }
</script>

